import { forEachPolyfill } from './functions';
forEachPolyfill();

export default function() {
    const faqTitles = document.querySelectorAll(".faq-item__title");
    
    // stop function if there're no FAQ on the page
    if (!faqTitles) return;

    // Toggle item state
    faqTitles.forEach(item => {
        item.addEventListener('click', () => {
            item.parentNode.classList.toggle('active');
        });        
    });
}